<template>
    <div>
        <div
            class="sign-container"
            :class="{'full-screen': signSource === 'ZWDT_OPEN', 'iframe-container': hideFrame}"
        >
            <template>
                <div class="header">
                    <h4 class="text-center">文件电子印章</h4>
                    <div class="header-ctrl text-right">
                        <el-button
                            type="primary"
                            class="sign-btn"
                            @click="doConfirmSign()"
                        >
                            完成签署
                        </el-button>
                    </div>
                </div>
            </template>

            <!-- ukey签署 -->
            <ukey-password-confirm
                :visible.sync="visibleUkey"
                v-if="visibleUkey"
                @onConfirm="handlePreSign"
            />
            <sign-progress
                :visible.sync="visibleProgress"
                v-if="visibleProgress"
                :percentage="percentage"
                :signedUum="signedNum"
                :total="total"
                :signError="signError"
                :isReady="ready"
            />
            <ukey-dialog
                v-if="showUkeyDialog"
                :showUkeyDialog.sync="showUkeyDialog"
            />
        </div>
    </div>
</template>

<script>
import qs from 'qs';
import UkeyPasswordConfirm from './childs/ukey-password-confirm.vue';
import SignProgress from './childs/sign-progress.vue';
import UkeyDialog from './ukey-dialog.vue';
import { keyType, keyUsage } from "../../components/ukey/keyModel";

export default {
    name: "app",

    components: {
        UkeyPasswordConfirm,
        SignProgress,
        UkeyDialog
    },

    inject: ['app'],

    data () {
        return {
            pin: '',
            url: '', // pdf文件路径
            contract: {}, // 文件详情
            digest: '', // 签署摘要
            sm2digest: '', //sm2 摘要
            signKey: '', // 签署key 值
            signAlg: '', // 签名算法类型 :string = SM2 | RSA
            locations: [], // 请求二维码签章数据
            rectangles: [], // 指定签章位置
            documents: [], // 文档信息
            currentDocument: {}, // 当前签署文档
            datePattern: 'SECONDARY_THIRD', // 时间戳格式
            signData: '', // 签署数据
            visibleUkey: false,
            sm2Cert: '',
            isZWFWSEAL: false,
            sealInfo: {},
            imageUrl: '',
            verify: false,
            signedNum: 0,
            visibleProgress: false,
            percentage: 0,
            showUkeyDialog: false,
            total: 0,
            signError: false,
            ready: true,
        };
    },

    computed: {
        cert() {
            return this.app && this.app.cert || '';
        },
        // token 秘钥
        zwdt_access_token() {
            return this.$route.query.zwdt_access_token;
        },
        // 签署来源
        signSource() {
            return this.$route.query.signSource;
        },
        // 是否是UKEY签署
        isUkeySign() {
            return ["SEAL_UKEY", 'SEAL_UKEY_PERSON'].includes(this.signType);
        },
        // 签署类型
        signType() {
            return this.contract.signType || '';
        },
        currSignatory() {
            return this.contract && this.contract.signatories && _.find(this.contract.signatories, item => item.id === this.contract.signatoryId) || {};
        },
        hasAppointLocation() {
            return this.currSignatory.locations && this.currSignatory.locations.length;
        },
        signStatus() {
            return this.currSignatory && this.currSignatory.status;
        },
        isReady() {
            console.log(this.app)
            return this.app.sealData && this.app.picData && this.isUkeySign && this.app.ukey.init;
        },
        hideFrame() {
            return this.$route.query.hideFrame && this.$route.query.hideFrame !== 'false';
        },
        openApi () {
            return '';
        },
    },
    watch: {
        isReady: {
            async handler (nv) {
                if (nv && !['COMPLETE', 'FAILED'].includes(this.contract.status)) {
                    this.hasUkey = true;
                    await this.getLpSignInfo();
                    this.showUkeyDialog = false;
                    this.doConfirmSign();
                    this.loading.close();
                }
            },
            immediate: true
        },
    },

    methods: {
        /**
         * 获取文件详情
         */
        async getContractDetail(noLoad) {
            let resp, loading;
            try {
                if (!noLoad) {
                    loading = this.$loading({
                        text: '努力加载中...'
                    });
                }
                resp = await this.axios({
                    url: this.openApi + '/zwdt/view/detail',
                    method: 'GET',
                    params: { zwdt_access_token: this.zwdt_access_token },
                    headers: { zwdt_access_token: this.zwdt_access_token }
                });
                resp = resp.data;
                resp.contract.docuemnts = resp.contract.documents.map(doc => {
                    doc.page = doc.page.map(page => {
                        const ZOOM_MM_IN = 595 / 210; // 英寸/mm 缩放比例
                        page.width = parseInt(page.pixelWidth / ZOOM_MM_IN);
                        page.height = parseInt(page.pixelHeight / ZOOM_MM_IN);
                        return page;
                    })
                    return doc;

                })
                this.contract = resp.contract;
                this.documents = resp.contract.documents;
                this.currentDocument = this.documents[0];
                this.url = '';
                this.$nextTick(() => {
                    if (this.signStatus === 'SIGNING') {
                        if(this.currSignatory.locations.length) {
                            this.handleRectangles(this.currSignatory.locations);
                        }
                    } else {
                        this.rectangles = [];
                    }
                    this.rectangles?.forEach(rectangle => {
                        if (rectangle.rectType === 'TIMESTAMP') {
                            let originTimestampFormatType = rectangle.timestampFormatType;
                            // 有预设位置的时间戳格式不可更改，故添加字段标识
                            this.$set(rectangle, 'isAppointTimestampFormatType', !!originTimestampFormatType);
                            this.$set(rectangle, 'timestampFormatType', originTimestampFormatType || this.datePattern);
                            const { timestampFormatType, fontSize, fontType } = rectangle;
                            const src = this.getTimeStampImage(timestampFormatType, fontSize, fontType);
                            this.$set(rectangle, 'src', src);
                        }
                    });
                    this.url = `${this.BASE_APP_PATH}/zwdt/view/document/download?documentId=${this.currentDocument.id}&zwdt_access_token=${this.zwdt_access_token}&cd=${Date.now()}`;
                });
            } catch (error) {
                console.log(error);
            } finally {
                loading && loading.close();
            }
        },

        getTimeStampImage(formatType = 'SECONDARY_THIRD', fontSize, fontType) {
            const param = { formatType, fontSize, fontType, zwdt_access_token: this.zwdt_access_token || this.$route.query.zwdt_access_token };
            return `${this.BASE_APP_PATH}/seal/timestamp?${qs.stringify(param)}`;
        },

        /**
         * 处理指定签署位置
         */
        handleRectangles(rectangles) {
            this.rectangles.splice(0);
            rectangles.forEach(rectangle => {
                this.rectangles.push(rectangle);
            });
        },

        /**
         * 获取ukey 签署数据
         */
        async doSignByUkey(opts) {
            const isRSA = opts.signAlg === 'RSA';
            const paramsData = isRSA ? {
                data: opts.digest,
                pwd: this.pin,
                algid: 4,
                isHex: true
            } : {
                data: opts.digest,
                pwd: this.pin,
                asymid: keyType.K_SHCA_ASYMID_SM2,
                algid: 4,
                isHex: true
            };
            if (this.Utils.isIE()) {
                if (isRSA) {
                    await this.app.ukey.initService(this.pin);
                } else {
                    await this.app.ukey.initSm2Service(this.pin);
                }
            }
            let resp = await this.app.ukey.sign(paramsData);
            opts.signData = resp.result;
        },

        async sign(opts) {
            let res = await this.axios({
                url: this.openApi + '/zwdt/view/czbbatchsign',
                method: 'POST',
                data: {
                    pwd: this.pin,
                    key: opts.key,
                    index: opts.index,
                    cert: this.cert,
                    digest: opts.digest,
                    signAlg: opts.signAlg,
                    base64SignedData: opts.signData,
                },
                params: { zwdt_access_token: this.zwdt_access_token },
                headers: { zwdt_access_token: this.zwdt_access_token }
            });
            res = res.data;
            if (res.code === 0) {
                return res;
            } else {
                this.signedNum = res.documentSignIndex;
                this.percentage = (this.signedNum * 100) / this.total;
                this.signError = true;
                this.$message.error(res.message);
                return '';
            }
        },

        /**
         * 签署前校验
         */
        handlePreSign(pin) {
            this.pin = pin;
            this.handleUkeySign();
        },

        handleUkeySign() {
            let loadingError;
            try {
                this.signLoop();
            } catch (error) {
                if (error.code == '2181300449') {
                    // UKEY服务忙时禁止用户操作10s
                    loadingError = this.$loading({
                        text: '服务忙，请稍后再试...'
                    });
                    setTimeout(() => {
                        loadingError && loadingError.close();
                    }, 10000);
                } else {
                    error.message && this.$message.error(error.message);
                }
                console.log(error);
            }
        },

        async signLoop () {
            // 循环
            let endLoop = false;
            // 签名数据
            let opts = {
                index: '',
                key: '',
                signAlg: '',
                digest: '',
                // sm2digest: '',
                signData: '',
            };
            try {
                let sm2Cert = await this.app.ukey.getCert(keyType.K_SHCA_ASYMID_SM2, keyUsage.K_SHCA_USAGE_SIGN);
                this.sm2Cert = encodeURIComponent(sm2Cert.result);
                const resp = await this.getSignAbstract(opts);
                if (resp.code === 0) {
                    while (!endLoop) {
                        this.visibleProgress = true;
                        await this.doSignByUkey(opts);
                        const res = await this.sign(opts);

                        if (!res) {
                            endLoop = true;
                            this.signError = true;
                            console.log('error', res);
                        } else if (res.complete) {
                            this.signedNum = res.documentSignIndex;
                            this.percentage = (this.signedNum * 100) / this.total;
                            if (res.successPage) {
                                this.jumpToSuccessPage(res.successPage, res.preview);
                            }
                            endLoop = true;
                        } else {
                            opts.digest = res.digest;
                            opts.key = res.key;
                            opts.index = res.index;
                            opts.signAlg = res.signAlg;
                            this.signedNum = res.documentSignIndex;
                            this.percentage = (this.signedNum * 100) / this.total;
                        }
                    }
                } else {
                    this.$message.error(resp.message);
                }
            } catch (e) {
                console.log(e);
                this.ready = false;
                if (typeof e === 'string') {
                    this.$message.error(e);
                } else if (e && e.message) {
                    this.$message.error(e.message);
                }
            }
        },

        async getSignAbstract (opts) {
            let resp, sealData;
            sealData = this.isZWFWSEAL ? 'sm2SealData' : 'rsaSealData';
            let data = {
                sealSn: this.sealInfo.seal_sn,
                seal: this.imageUrl.split(',')[1],
                cert: this.cert,
                sm2Cert: this.sm2Cert,
                [sealData]: encodeURIComponent(this.sealInfo.sealData),
            };
            resp = await this.axios({
                url: this.openApi + '/zwdt/view/start/czbbatchsign/lp',
                method: 'POST',
                data,
                params: { zwdt_access_token: this.zwdt_access_token },
                headers: { zwdt_access_token: this.zwdt_access_token }
            });
            resp = resp.data;
            opts.digest = resp.digest;
            opts.key = resp.key;
            opts.index = resp.index;
            opts.signAlg = resp.signAlg;
            this.total = resp.documentSize;
            return resp;
        },

        validateSignLocation() {
            if (!this.isReady) {
                this.loading = this.$loading({
                    text: 'UKEY 连接中...'
                });
            }
            if (!(this.app.ukey.init)) {
                this.$message.warning('请先安装UKEY驱动并插入UKEY');
                this.showUkeyDialog = true;
                return;
            }
            if (!this.imageUrl) {
                this.$message.warning('请等待印章图片加载完成');
                return;
            }

            if (!this.verify) {
                this.$message.warning('无效印章');
                return;
            }
            return true;
        },

        // 确认签署
        async doConfirmSign() {
            const res = this.validateSignLocation();
            if (this.isUkeySign && res) {
                this.visibleUkey = true;
            }
        },

        // Ukey 配置
        async getLpSignInfo () {
            try {
                let requsetData = new FormData();
                requsetData.append('sealData', this.app.sealData);
                requsetData.append('old', this.app.isOld);
                requsetData.append('picData', this.app.picData);
                requsetData.append('cert', this.cert);
                await this.getSealVerify(requsetData);
            } catch (err) {
                this.hasUkey = false;
                console.log(err);
            }
        },

        /**
         * 印章有效性验证
         */
        async getSealVerify (requsetData) {
            let resp = await this.axios({
                url: `/zwdt/view/seal/verify`,
                method: 'POST',
                params: { zwdt_access_token: this.zwdt_access_token },
                data: requsetData,
                headers: { zwdt_access_token: this.zwdt_access_token }
            });
            resp = resp.data;
            if (resp.code === 0) {
                this.isZWFWSEAL = resp.result.sealStructure === "ZWFWSEAL";
                if (resp.result.pic_data) {
                    this.sealInfo = resp.result;
                    this.verify = resp.result.seal_status == 1;
                    this.imageUrl = `data:image/png;base64,${resp.result.pic_data}`;

                    // 自动盖章，仅针对ukey 法人章
                    if (this.rectangles.length) {
                        this.rectangles.forEach(rectangle => {
                            // ukey 法人章
                            if (rectangle.rectType !== 'TIMESTAMP') {
                                this.$set(rectangle, 'src', this.imageUrl);
                            }
                        });
                    }

                }
            }
        },
    },


    async mounted() {
        document.getElementById('app').classList.add('adjust-height');
        await this.getContractDetail();
        if (this.contract.status === 'COMPLETE') {
            this.visibleProgress = true;
            this.signedNum = this.contract.docuemnts.length;
            this.percentage = 100;
            this.total = this.contract.docuemnts.length;
        } else if (this.contract.status === 'FAILED') {
            this.visibleProgress = true;
            this.signError = true;
        } else {
            this.doConfirmSign();
        }
    },

    beforeDestroy() {
        document.getElementById('app').classList.remove('adjust-height');
    },
};
</script>

<style lang="less">
.custom-dialog {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 250px;
    .el-dialog__body {
        position: relative;
    }
    .count-down-desc {
        position: absolute;
        top: -10px;
        left: 140px;
        color: #ff0000;
    }
    p {
        text-align: center;
    }
}
.el-dialog {
    .el-form-item__label {
        color: #333333;
    }

    .el-form-item__content {
        h4 {
            color: #333333;
        }
    }

    .el-dialog__title {
        color: #333333;
    }
}

.el-input__inner {
    &:focus {
        border-color: #1491ff;
    }
}

.el-loading-spinner .el-loading-text {
    color: #1491ff;
}
.el-loading-spinner .path {
    stroke: #1491ff;
}

.el-input-group__append {
    color: #333333;
    .el-button--default {
        opacity: 0.3;
    }
}

.el-button--primary {
    background: #1491ff;
    border-color: #1491ff;
    &:hover {
        background: #1491ff;
        border-color: #1491ff;
    }
}

#app.adjust-height {
    height: 100%;
}
.pdf-document-thumbnail {
    .pdf-thumbnail-item {
        .pdf-thumbnail-item__image.is-selected {
            border-color: #1491ff;
        }
    }
}
.sign-container {
    &.iframe-container {
        min-height: 620px;

        .contract-sign {
            height: 100%;
        }

        .contract-seal {
            width: 200px;

            .seal-image {
                width: 160px;
            }
        }

        .pdf-thumbnail {
            img {
                border: 2px solid transparent !important;
            }
        }

        .pdf-viewer__preview {
            width: 180px;
            left: calc(100% - 180px);
        }
        .pdf-viewer__document.preview-enabled {
            width: calc(100% - 180px);
            right: 180px;
        }
    }

}
</style>
<style lang="less" scoped>
.sign-container {
    //min-height: 800px;
    background: @background-color;

    .text-center {
        font-size: 20px;
    }

    .sign-btn {
        background: #1491ff;
        border-color: #1491ff;
    }

    .menu-footer {
        padding: 20px;
    }

    &.full-screen {
        height: 100vh;

        .contract-sign {
            height: calc(100vh - 90px);
        }
    }

    .rectangle {
        position: relative;
        border: 1px dashed @border-color-drak;
        background: rgba(188, 0, 0, 0.1);
        cursor: move;
        .delete-icon {
            position: absolute;
            display: block;
            background: @white;
            border-radius: 10px;
            top: -6px;
            right: -6px;
            cursor: pointer;
        }
        .stamper-image {
            position: absolute;
            top: 0;
            left: 0;
            max-width: none;
            height: 100%;
        }
    }

    .header {
        height: 60px;
        line-height: 60px;
        padding: 0 20px;
        margin-bottom: 30px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        background: @white;
        box-shadow: 0 5px 5px 2px @black-opacity-1;
        border-top: 1px solid @border-color-base;

        .header-ctrl {
            width: 240px;
        }

        h4 {
            flex: 1;
        }
    }

    .contract-sign {
        display: flex;
        height: calc(100vh - 60px);
        background: @background-color;

        &.height-adjust {
            height: 1000px;
        }

        .contract-seal {
            min-width: 300px;
            height: 100%;
            padding: 0 50px;
            // width: 30%;
            overflow: auto;

            display: flex;
            justify-content: space-between;
            flex-direction: column;
        }

        .contract-container {
            position: relative;
            flex: 1;
            background-color: #3c3c3c;
        }
    }
    .sign-button {
        position: absolute;
        bottom: -32px;
        right: -40px;
    }
    .across-page .sign-button {
        left: -40px;
    }
    .sign-footer {
        line-height: 80px;
        border-top: 1px solid @border-color-base;
    }
    .qr-code {
        position: absolute;
        top: 18px;
        left: 18px;
        z-index: 100;
        width: 41px;
        height: 41px;

        i {
            position: absolute;
            cursor: pointer;
            right: -5px;
            top: -5px;
        }
    }
}
.qr-dialog {
    .qr-tip {
        text-align: center;
        margin-bottom: 10px;
    }
    .expire-tips {
        margin: 25px;
    }
    .qr-content {
        position: relative;
        margin: 0 auto;
        width: 147px;
        color: @white;
    }
    .expire-img {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: rgba(0, 0, 0, 0.5);
        text-align: center;
    }
    .expire-time {
        text-align: center;
        color: @red;
    }
}
</style>


